<template>
  <el-dialog 
    :title="openType === 'add' ? '新增角色' : '编辑角色'"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="60%"
    custom-class="customModal">
    <el-form ref="form" :model="formValue" :rules="rules">
      <el-form-item label="角色名称" prop="role_name" class="formItemFill">
        <el-input v-model="formValue.role_name" size="small" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="权限列表" prop="act_list">
        <el-row>
          <el-col class="treeTable">
            <Tree
            defaultExpandAll
            checkable
            checkStrictly
            v-model="formValue.act_list"
            :treeData="treeData"
            :replaceFields="{ children: 'sub', title: 'name', key: 'id' }">
            </Tree>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="角色描述" prop="role_desc" class="formItemFill">
        <el-input v-model="formValue.role_desc"
          type="textarea"
          :rows="2"
          placeholder="请输入内容"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <AppButton type="primary" :asyncClick="submit" size="small">提交</AppButton>
      <AppButton @click="close" size="small">取 消</AppButton>
    </div>
  </el-dialog>
</template>

<script>
import { RoleService } from '../../service/role.service';
import { Tree } from 'ant-design-vue';
  export default {
    name: 'formRole',
    components: { Tree },
    props: [ 'addSuccess' ],
    data() {
      return {
        visible: false,
        openType: '',
        treeData: [],
        formValue: {},
        treeValue: [],
        checkAll: false,
        showTreeError: false,
        rules: {
          role_name: [{ required: true, message: '角色名称不能为空'}],
          role_desc: [{ required: true, message: '角色描述不能为空'}],
          act_list: [{ required: true, type: 'array', min: 1, message: '请选择角色权限', trigger: 'check' }]
        },
      }
    },
    async created() {
      this.getTreeData();
    },
    activated() {
      this.getTreeData();
    },
    methods: {
      async getTreeData() {
        const data = await RoleService.getFormTreeData();
        this.treeData = [{
          name: '全部权限',
          class: 'AppMenu',
          id: 0,
          sub: data,
        }]
      },
      open(type, data) {
        if (type === 'add') {
          this.reset();
        } else if (type === 'edit' && data) {
          if (data.power.indexOf('all') > -1) {
              this.treeValue = [0];
          } else if(data.power) {
            const treeValue = data.power.map(v => +v);
            this.checkNewPower(this.treeData, treeValue);
            const list = [];
            this.handleAuthWhileEdit(this.treeData, list);
            this.treeValue = treeValue.filter(i => (list.indexOf(i) > -1));
          }
          this.formValue = {
            role_id: data.roleInfo.role_id,
            role_name: data.roleInfo.role_name,
            role_desc: data.roleInfo.role_desc,
            act_list: this.treeValue || [],
          }
        }
        this.openType === type;
        this.visible = true;
        if (this.$refs.tree) {
          this.$refs.tree.setCheckedKeys(this.treeValue)
        }
      },
      handleAuthWhileEdit(treeData ,list = []) {
        if (treeData && treeData.length) {
          for (let i = 0; i < treeData.length; i++) {
            list.push(treeData[i].id);
            this.handleAuthWhileEdit(treeData[i].sub, list);
          }
        }
      },
      checkNewPower(data, value) {  // 新增权限时检查treeValue 避免新增权限因分类全选被勾选 造成被勾选却未给予权限
        if(data && data.length) {
          for(let i = 0;i < data.length;i++){
            this.checkNewPower(data[i].sub, value);
            if(value.indexOf(data[i].id) < 0 && value.indexOf(data[i].pid) > -1){
              value.splice(value.indexOf(data[i].pid), 1);
            }
          }
        }
      },
      reset() {
        if (this.$refs.form) {
          this.$refs.form.resetFields();
        }
        this.formValue = {};
      },
      async submit() {
        if(this.formValue.act_list.checked){
          this.formValue.act_list = this.formValue.act_list.checked;
        }
        this.$refs.form.validateField('act_list');
        const result = await this.$refs.form.validate();
        if (result) {
          const data = JSON.parse(JSON.stringify(this.formValue));
          if (data.act_list.indexOf(0) > -1) {
            data.act_list = 'all';
          } else {
            data.act_list = data.act_list.join(',');
          }
          await RoleService.addOrEditRole(data);
          this.$emit('addSuccess');
          this.close();
        }
      },
      close() {
        this.treeValue = [];
        this.visible = false;
      }
    }
  }
</script>

<style lang="scss" scoped>

.treeTable {
  height: 29vw;
  overflow-y: auto;
  overflow-x: hidden;
  .checkAll {
    display: flex;
  }
  & /deep/ .AppMenu {
    text-align: left;
    background: #f6f9fc;
    width: 100%;
    font-weight: bold;
    & > ul {
      background: #fff;
      display: flex;
      flex-wrap: wrap;
      border-top: 1px solid #e8e8e8;
    }
  }
  & /deep/ .ant-tree-child-tree > li:first-child {
    padding-top: 14px;
  }
  & /deep/ .Leaf {
    text-align: left;
    font-weight:normal;
    // width: 100px;
    float: left;
    margin: 5px 8px;
    padding: 14px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  & /deep/ .interface {
    background: #e9f0f4;
  }

  & /deep/ .view {
    background: #b6e2ff;
  }

}
</style>